"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchArea = void 0;
var React = require("react");
var Spinner_1 = require("../../../Animations/Spinner");
var CloseThickIcon_1 = require("../../../Icons/Assets/CloseThickIcon");
var SearchIcon_1 = require("../../../Icons/Assets/SearchIcon");
var Localization_1 = require("../../../Localization");
var Searcher_1 = require("../../../Searcher");
var SearchArea_styles_1 = require("./SearchArea.styles");
var Styles_1 = require("./Styles");
var SearchArea = function (_a) {
    var OnClearSearch = _a.OnClearSearch, OnSearch = _a.OnSearch;
    var _b = Searcher_1.useSearcher(OnSearch, OnClearSearch), triggerCancel = _b.triggerCancel, triggerSearch = _b.triggerSearch, isSearching = _b.isSearching, hasSearchValue = _b.hasSearchValue, inputProps = _b.inputProps;
    var renderIcon = function () {
        if (isSearching) {
            return React.createElement(Spinner_1.Spinner, { Size: "16px" });
        }
        else if (hasSearchValue) {
            return React.createElement(CloseThickIcon_1.CloseThickIcon, { Height: "24px", Width: "24px" });
        }
        else {
            return React.createElement(SearchIcon_1.SearchIcon, { Height: "24px", Width: "24px" });
        }
    };
    return (React.createElement(SearchArea_styles_1.SearchHeader, null,
        React.createElement(Styles_1.HeaderLabel, { htmlFor: "FieldSelectorSearch" }, Localization_1.strings.FieldSelector_Label_AvailableFields),
        React.createElement(SearchArea_styles_1.SearchInput, null,
            React.createElement(SearchArea_styles_1.Input, __assign({}, inputProps, { "aria-label": Localization_1.strings.FieldSelector_Label_SearchFieldList, spellCheck: false, name: "search", id: "FieldSelectorSearch", placeholder: Localization_1.strings.FieldSelector_Message_SearchForFields })),
            React.createElement(SearchArea_styles_1.Button, { type: "button", onClick: hasSearchValue ? triggerCancel : triggerSearch, title: hasSearchValue
                    ? Localization_1.strings.FieldSelector_Message_ClearThisSearch
                    : Localization_1.strings.FieldSelector_Message_SearchForFields }, renderIcon()))));
};
exports.SearchArea = SearchArea;
